import {Injectable} from '@angular/core';

@Injectable()
export class FormModalService {
    formModal: boolean;
    formType: string;
    show: boolean = false;
    callback;
    constructor(){
        this.formModal = null;
    }

    showFormModal(content, callback){
        this.formType = content;
        this.show = true;
        this.callback = callback;
    }

    getFormModal(id){
        if (this.show){
            this.formModal = this.formType == id ? true : false;
            return this.formModal;
        }
    }

    hideFormModal(executeCallback){
        if(executeCallback){
            this.callback();
        }
        this.show = false;
        this.formModal = false;
    }

}



// WEBPACK FOOTER //
// ./public/upgrade/root/form-modal/form-modal.service.ts